import axios from 'axios';

const defaultState = {
  list: [],
  roles: []
};

export default {
  namespaced: true,

  state: {
    list: [],
    usersLoading: false,
    roles: []
  },

  mutations: {
    setUsers(state, data) {
      state.list = data;
    },

    setUsersLoading(state, isloading) {
      state.usersLoading = isloading;
    },

    setRoles(state, roles) {
      state.roles = roles;
    },

    resetState(state) {
      Object.assign(state, defaultState);
    }
  },

  actions: {
    getAllUsers({ commit, dispatch }) {
      return axios.get(process.env.VUE_APP_API_URL + 'users')
      .then(({ data }) => commit('setUsers', data))
      .catch(({ response }) => dispatch('handleResponse', response, { root: true }));
    },

    deleteUser({ commit, state }, userid) {
      return axios.delete(process.env.VUE_APP_API_URL + `users/${userid}`)
      .then(() => {
        const remaining = state.list.filter(user => user.uuid !== userid);
        commit('setUsers', remaining);
      });
    },

    addUser({ commit, state }, new_user) {
      return axios.post(process.env.VUE_APP_API_URL + 'users', new_user)
      .then(({ data }) => {
        let users = [ ...state.list ];
        users.push(data);
        commit('setUsers', users);
      });
    },

    getAllRoles({ commit }) {
      return axios.get(process.env.VUE_APP_API_URL + 'roles')
      .then(({ data }) => {
        commit('setRoles', data);
      });
    },

    updateUser({ commit, state }, user) {
      return axios.put(process.env.VUE_APP_API_URL + 'users', user)
      .then(({ data }) => {
        let users = [ ...state.list ];
        users = users.filter(usr => usr.uuid !== data.uuid);
        users.push(data);
        commit('setUsers', users);
      });
    },

    updateStatus({ commit, state }, { status, userID }) {
      return axios.put(`${process.env.VUE_APP_API_URL}users/${userID}/update-status`, { status })
        .then(({ data }) => {
          let users = [ ...state.list ];
          let index = users.findIndex(usr => usr.uuid === userID);
          users = [ ...users.slice(0, index),  data, ...users.slice(index+1)];
          commit('setUsers', users);
        });
    }
  }
};